export default function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="#EA4335"
        d="M9 3.48c1.69 0 2.85.73 3.5 1.34l2.55-2.49C13.45.86 11.42 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
      />
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.49h4.84c-.21 1.12-.84 2.07-1.79 2.71l2.83 2.2c1.66-1.53 2.76-3.78 2.76-6.56z"
      />
      <path
        fill="#FBBC05"
        d="M3.88 10.78c-.18-.55-.29-1.14-.29-1.78s.1-1.23.29-1.78L.96 4.96A8.99 8.99 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.83-2.2c-.79.53-1.81.85-3.13.85-2.38 0-4.4-1.57-5.13-3.74l-2.92 2.26C2.44 15.98 5.48 18 9 18z"
      />
    </svg>
  );
}
